module.exports = __webpack_public_path__ + "static/media/jinray-resort.834ecf48.jpg";